import { FieldSelect } from '@dixa/lib-shared-habla';
import { Field } from 'redux-form';
import { DeepWritable } from 'ts-essentials';

import { UserModalState } from 'components/usersModal/userModal.reducer';
import { selectUserModal } from 'components/usersModal/userModal.selectors';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { useCurrentUser } from 'utils/user';

import {
  getLegacyRolesOptions,
  getLegacyRolesTooltipContent,
} from './legacyRolesField.utils';

type LegacyRolesFieldProps = {
  required: boolean;
  disabled: boolean;
};

export const LegacyRolesField = ({
  required,
  disabled,
}: LegacyRolesFieldProps): JSX.Element => {
  const { user: currentUser } = useCurrentUser();
  const userModalState = useAppSelector<UserModalState>(selectUserModal);

  return (
    <Field
      label="Role"
      name="role"
      placeholder="Select a role"
      helpIcon={{
        text: getLegacyRolesTooltipContent(
          currentUser.id === userModalState.userId,
        ),
        dark: true,
      }}
      component={FieldSelect}
      items={getLegacyRolesOptions(
        currentUser.roles as DeepWritable<typeof currentUser.roles>,
      )}
      disabled={disabled}
      required={required}
    />
  );
};
